import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";

const FaqComponent = () => {
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleIndex = (index) => {
        if (index === selectedIndex) {
            setSelectedIndex(-1);
        } else {
            setSelectedIndex(index);
        }
    }

    const rows = [
        {
            title: `${t("1. Is P2PTrade Safe")}?`,
            content: t(`In order to achieve security P2PTrade uses a 2-of-2 multi-signature address to safeguard every crypto exchanged on our platform. Trade disputes are resolved using a three-tier system that combines mediation and end-to-end encrypted trader chat. Since fiat transactions can frequently be reversed, there is always some chargeback risk when exchanging fiat currency for crypto. We recommend trading with buyers that are KYC and verified. P2PTrade only accepts payment methods known to be challenging for chargebacks; as a result, We do not accept PayPal or credit cards, for instance.`),
        },
        {
            title: t("2. What are transaction fees?"),
            content: t("P2PTrade charges a 0.45% transaction fee on trades relatively lower than most centralized p2p. Transaction fees are automatically deducted from both parties by the smart contract."),
        },
        {
            title: t("3. How does P2PTrade handle fiats like dollars and euros? Where does it go?"),
            content: t("P2PTrade does not handle fiat at all. Every trade on our platform is settled outside of P2PTrade. In order words, fiat payments are sent outside P2PTrade via traditional banking services."),
        },
        {
            title: t("4. Does P2PTrade require a security deposit?"),
            content: t("As of now, P2PTrade does not require a security deposit. However, crypto sellers for fiat are required to deposit the asset they want to trade for cash into our secured smart contract before receiving fiat. On the other hand, buyers (Fiat Providers) are not required to deposit crypto. One-time KYC for buyers is optional but highly recommended to remain a verified buyer on the platform, which increases seller trust."),
        },
        {
            title: t("5. Which payment methods are available?"),
            content: t("P2PTrade accepts over 20 different payment methods such as Zelle, Cashapp, Venmo, Apple Pay, Wechat, and many more. Navigate through the platform for a complete list of all payment methods.",)
        },
        {
            title: t("6. How long does a trade take?"),
            content: t("P2PTrade does not offer automatic order matching. All trades are settled manually by humans outside the P2PTrade P2P platform. Trades can still be completed quite rapidly even though they take longer than they would on Centralized exchanges. Most payment methods on P2PTrade platform are instant while others may take a few days such as certain bank transfers."),
        },
        {
            title: t("7. How does P2PTrade protect my privacy?"),
            content: t("Personal information of users such as names, email, phone number etc. Are not required to use on our platform. Our platform does not have a database and every payment information is stored on the Smart Contract."),
        },
        {
            title: t("8. How does P2PTrade protect my data?"),
            content: t("P2PTrade does not store data at all, and has no backend server. Our technology uses only the front end and smart contract. We do not store user data or payment information. We use two types of keys; the private key is used to decrypt messages while the public key can only encrypt messages. For example, A buyer's public key is made public when they create an offer in the smart contract. When a seller wants to interact with a buyer's offer, the seller uses the buyer's public keys to encrypt his/her payment information which is sent to the smart contract. The buyer then decrypts the data with his private key."),
        },
    ]

    return (
        <div className="">
            {
                rows.map((row, index) => 
                    <div key={index} className={`mb-8 text-left cursor-pointer ${index === selectedIndex ? "border-2 border-first-theme rounded-lg" : ""}`} onClick={() => handleIndex(index)}>
                        <div className="text-lg p-4 bg-first-theme rounded-lg flex justify-between items-center">{row.title}{index === selectedIndex ? <AiOutlineUp /> : <AiOutlineDown />}</div>
                        <div className={`text-second-theme p-4 ${index === selectedIndex ? "block" : "hidden"}`}>{row.content}</div>
                    </div>
                )
            }
        </div>
    );
}

export default FaqComponent;